
define('text!modules/player/player_template.html',[],function () { return '<div class="movie-player js-movie"></div>\r\n<div class="js-player-list"></div>\r\n';});

